export const GET_ALL_OPERATORS_REQUEST = " GET_ALL_OPERATORS_REQUEST";
export const GET_ALL_OPERATORS_SUCCESS = " GET_ALL_OPERATORS_SUCCESS";
export const GET_ALL_OPERATORS_FAILURE = " GET_ALL_OPERATORS_FAILURE";
